<template>
  <div class="row">
    <template v-if="isCalculatorApplicant">
      <div class="col-12 col-md-12 q-mt-xl-md">
        <div class="q-pa-md border-radius-top q-pt-md-none">
          <CalculatorIdentityVerification
            :makeHeaderActive="activeIdentityVerification"
            :enable="enableIdentityVerification"
            @identityVerificationCreated="identityVerificationCreated"
          />
          <CalculatorApplicationReview
            :makeHeaderActive="activeApplicationReview"
            :enable="enableApplicationReview"
            @applicationReviewCreated="applicationReviewCreated"
            v-if="isUserPrimaryApplicant"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="!(isWetSignature && isUserSecondaryApplicant)" class="col-12 col-md-4">
        <ProgressSteps :step="step"></ProgressSteps>
      </div>
      <div
        :class="isWetSignature && isUserSecondaryApplicant ? 'col-12 col-md-12' : 'col-12 col-md-8'"
        :style="isWetSignature && isUserSecondaryApplicant ? 'padding-top: 25px' : ''"
      >
        <div class="q-pa-md border-radius-top q-pt-md-none">
          <IdentityVerification
            :makeHeaderActive="activeIdentityVerification"
            :enable="enableIdentityVerification"
            @identityVerificationCreated="identityVerificationCreated"
          />
          <ApplicationReview
            :makeHeaderActive="activeApplicationReview"
            :enable="enableApplicationReview"
            @applicationReviewCreated="applicationReviewCreated"
            v-if="isUserPrimaryApplicant"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import IdentityVerification from './IdentityVerification.vue';
import ApplicationReview from './ApplicationReview.vue';
import CalculatorIdentityVerification from '@/pages/CalculatorAuth/Approvals/IdentityVerification';
import CalculatorApplicationReview from '@/pages/CalculatorAuth/Approvals/ApplicationReview';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';

export default {
  name: 'ApplicationReviewIndex',
  mixins: [MyCustomFunctions],
  data: function () {
    return {
      activeIdentityVerification: true,
      activeApplicationReview: false,
      enableIdentityVerification: true,
      enableApplicationReview: false
    };
  },
  components: { ProgressSteps, IdentityVerification, ApplicationReview, CalculatorIdentityVerification, CalculatorApplicationReview },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    ...mapGetters({
      isWetSignature: 'vehicleApplication/isWetSignature',
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant',
      isUserSecondaryApplicant: 'vehicleApplication/isUserSecondaryApplicant',
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    secondaryApplicant() {
      return this.scoreboard?.secondaryApplicant ? this.scoreboard?.secondaryApplicant : null;
    },
    step() {
      if (this.isUserPrimaryApplicant) return 3;
      else return 1;
    },
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    }
  },
  created() {
    if (this.isUserPrimaryApplicant) {
      if (this.primaryApplicant && this.primaryApplicant.identityVerificationStatus == 'completed') {
        this.identityVerificationCreated();
      } else return;

      if (this.primaryApplicant && this.primaryApplicant.applicationReviewStatus == 'completed') {
        this.applicationReviewCreated();
      }
    } else {
      if (this.secondaryApplicant && this.secondaryApplicant.identityVerificationStatus == 'completed') {
        this.identityVerificationCreated();
      } else return;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    identityVerificationCreated: async function () {
      this.activeIdentityVerification = false;
      this.enableIdentityVerification = false;
      if (this.isUserPrimaryApplicant) {
        this.activeApplicationReview = true;
        this.enableApplicationReview = true;
      }
      if (this.isUserSecondaryApplicant) {
        await this.updateVehicleApplication('reviewAndSignContract', 'statusSecondary');
        if (this.isWetSignature) this.$router.push({ name: 'wet-signature-secondary' });
        else this.$router.push({ name: 'reviewAndSignContract' });
      }
    },
    applicationReviewCreated: async function (statusType = 'none') {
      this.activeApplicationReview = false;
      this.enableApplicationReview = false;
      if (this.scoreboard && this.scoreboard.status != 'reviewAndSignContract') {
        await this.updateVehicleApplication('reviewAndSignContract', 'status');

        if (statusType === 'secondary-completed') this.$router.push({ name: 'approvals-waiting' });
        else if (statusType === 'secondary-not-completed') this.$router.push({ name: 'application-on-hold' });
        else this.$router.push({ name: 'reviewAndSignContract' });
      }
    }
  }
};
</script>
